import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import BtnRounded from '../../Components/btn/btnRounded';
import { AppConfigContext } from '../../Config/App';
import { LanguageContext } from '../../Data/Context/languageContext';

const PageNotFound = ({classes}) => {
    const { assets_url, navigate_to } = useContext(AppConfigContext);
    const { t } = useContext(LanguageContext);

    return (
        <div className={classes}>
            <div className="d-flex justify-content-center flex-wrap flex-column align-content-center align-items-center p-sm-5 col-12 col-sm-10 col-md-8 col-lg-6 mx-auto">
                <img loading="lazy" className="img-fluid" src={assets_url("404-pokeland-builder.webp")} alt="Pokeland Legends"></img>
                <div>
                    <Link to={navigate_to()}>
                        <BtnRounded classes={"mt-4"}>{t("go_back_to_homepage")}</BtnRounded>
                    </Link>
                </div>
            </div>
        </div>
    );
}
export default PageNotFound;